import type {AccessTokenService} from '@/domain/interfaces/AccessTokenService';
import {decodeJwt, isTokenExpired} from '@/domain/services/jwt';

export class IsTokenValidUseCase {
  constructor(private readonly repository: AccessTokenService) {}
  execute = async () => {
    const access_token = await this.repository.get();
    const accessToken = access_token ? decodeJwt(access_token) : undefined;
    return !!accessToken && !isTokenExpired(accessToken, 0);
  };
}
